import React, { FC } from 'react'

import { TPrivacyPolicyButton } from '../types/PrivacyPolicyButton.types'
import { PrivacyPolicyButtonView } from './PrivacyPolicyButtonView'

export const PrivacyPolicyButton: FC<TPrivacyPolicyButton> = ({ icon, name, onClickHandler }) => (
  <PrivacyPolicyButtonView icon={icon} name={name} onClickHandler={onClickHandler} />
)
